export const getFeedbackCommentByUuid = uuid => state => state.feedbackComments[uuid];

export const getCommentsByFeedbackUuid = feedbackUuid => state =>
  Object.values(state.feedbackComments).filter(item => item.feedbackUuid === feedbackUuid);
